<template>
    <v-dialog
        :value="isOpen"
        scrollable
        max-width="700px"
        transition="slide-y-transition"
        eager
        @keydown.esc="onClose"
        @click:outside="onClose"
    >
        <v-card>
            <v-card-title>
                <h1 class="text-subtitle-1">
                    Wybierz montaże i procesy do dodruku
                </h1>
            </v-card-title>

            <v-card-text class="pa-0">
                <v-container fluid>
                    <v-row>
                        <v-col cols="12">
                            <v-data-table
                                v-model="orderProductComponentsSelectedToReprint"
                                :headers="orderProductComponentsHeaders"
                                :items="orderProductComponents"
                                show-select
                                :mobile-breakpoint="0"
                                hide-default-footer
                                disable-pagination
                            >
                                <template #item.productName="{item}">
                                    {{ item.productName }}
                                </template>
                                <template #item.componentName="{item}">
                                    {{ item.name }}
                                </template>
                                <template #item.amount="{item}">
                                    <v-edit-dialog
                                        :return-value.sync="item.amount"
                                        large
                                        lazy
                                        cancel-text="Anuluj"
                                        save-text="Zapisz"
                                    >
                                        <div class="d-inline-flex">
                                            {{ item.amount }}
                                            <v-icon color="primary" small class="ml-1">
                                                mdi-pencil
                                            </v-icon>
                                        </div>
                                        <template #input>
                                            <v-text-field
                                                v-model.number="item.amount"
                                                v-mask="'#######'"
                                                label="Nakład"
                                                required
                                                single-line
                                            />
                                        </template>
                                    </v-edit-dialog>
                                </template>
                            </v-data-table>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12">
                            <v-data-table
                                v-model="jobProcessesSelectedToReprint"
                                :headers="jobProcessesHeaders"
                                :items="filteredJobProcesses"
                                show-select
                                :mobile-breakpoint="0"
                                hide-default-footer
                                disable-pagination
                            >
                                <template #item.processName="{item}">
                                    {{ item.name }}
                                </template>
                            </v-data-table>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12">
                            <v-checkbox
                                v-model="createShipmentsOrder"
                                label="Utwórz zlecenie spedycyjne"
                            />
                        </v-col>
                    </v-row>
                </v-container>
            </v-card-text>

            <v-divider />

            <v-card-actions>
                <v-btn
                    color="error"
                    text
                    data-sentry-label="Anuluj"
                    :disabled="actionLoading"
                    @click="onClose"
                >
                    Anuluj
                </v-btn>
                <v-spacer />
                <v-btn
                    color="success"
                    text
                    data-sentry-label="Zatwierdź"
                    :loading="actionLoading"
                    :disabled="!canConfirm"
                    @click="onConfirm"
                >
                    Zatwierdź
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { mask } from 'vue-the-mask'
import { appConfig } from '@/config'

export default {
    name: 'ReprintJobDialog',
    directives: { mask },
    props: {
        isOpen: {
            type: Boolean
        },
        jobId: {
            type: Number,
            default: null
        },
        orderProducts: {
            type: Array,
            default: () => []
        },
        jobProcesses: {
            type: Array,
            default: () => []
        },
        actionLoading: {
            type: Boolean
        }
    },
    data() {
        return {
            orderProductComponents: [],
            createShipmentsOrder: false,
            orderProductComponentsSelectedToReprint: [],
            jobProcessesSelectedToReprint: [],
            orderProductComponentsHeaders: [
                {
                    text: 'Nazwa produktu',
                    value: 'productName',
                    sortable: false,
                },
                {
                    text: 'Nazwa komponentu',
                    value: 'componentName',
                    sortable: false,
                },
                {
                    text: 'Nakład',
                    value: 'amount',
                    sortable: false,
                    width: 130
                },
            ],
            jobProcessesHeaders: [
                {
                    text: 'Nazwa procesu',
                    value: 'processName',
                    sortable: false,
                }
            ]
        }
    },
    computed: {
        filteredJobProcesses() {
            return this.jobProcesses.filter((obj) => obj.id !== appConfig.common.processes.sendingTaskId && obj.id !== appConfig.common.processes.packingTaskId)
        },
        canConfirm() {
            return this.orderProductComponentsSelectedToReprint.length > 0 && this.jobProcessesSelectedToReprint.length > 0
        }
    },
    watch: {
        isOpen(value) {
            if (value) {
                this.orderProducts.forEach(orderProduct => {
                    this.orderProductComponents = JSON.parse(JSON.stringify(this.orderProductComponents.concat(orderProduct.orderProductComponents)))
                })

                const printProcess = this.jobProcesses.find(process => process.id === appConfig.common.processes.printTaskId)

                this.jobProcessesSelectedToReprint.push(printProcess)
            } else {
                setTimeout(() => {
                    this.orderProductComponents = []
                    this.orderProductComponentsSelectedToReprint = []
                    this.jobProcessesSelectedToReprint = []
                }, 500)
            }
        }
    },
    methods: {
        onConfirm() {
            const payload = {
                jobId: this.jobId,
                createShippingOrder: this.createShipmentsOrder,
                orderProductComponents: this.orderProductComponentsSelectedToReprint.map(item => ({
                    orderProductComponentId: item.id,
                    amount: item.amount,
                })),
                processes: this.jobProcessesSelectedToReprint.map(item => item.id)
            }

            this.$emit('on-confirm', payload)
        },
        onClose() {
            this.$emit('on-close')
        }
    }
}
</script>
